// src/components/AddEntryModal.jsx
import React, { useState, useEffect } from "react";
import "./AddEntryModal.css";

const AddEntryModal = ({ type, onClose, onCreate }) => {
  const [amount, setAmount] = useState("");
  const [paymentBy, setPaymentBy] = useState("");
  const [paymentMode, setPaymentMode] = useState("Cash");
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [note, setNote] = useState("");

  const [invoice, setInvoice] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  /* -----------------------------------
     Preview File
  ----------------------------------- */
  useEffect(() => {
    if (!invoice) return setPreviewUrl(null);

    if (invoice.type.includes("image")) {
      const url = URL.createObjectURL(invoice);
      setPreviewUrl(url);
    } else {
      setPreviewUrl("pdf");
    }
  }, [invoice]);

  /* -----------------------------------
     Submit
  ----------------------------------- */
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!amount.trim()) return alert("Amount required");

    onCreate({
      type,
      amount: Number(amount),
      paymentBy,
      paymentMode,
      date,
      note,
      invoice,
    });
  };

  /* -----------------------------------
     UI
  ----------------------------------- */
  return (
    <>
      <div className="entry-backdrop" onClick={onClose}></div>

      <div className="entry-modal slide-up">
        {/* HEADER */}
        <div
          className={
            type === "IN"
              ? "entry-header gradient-green"
              : "entry-header gradient-red"
          }
        >
          <div className="entry-header-icon">
            {type === "IN" ? "⬇️" : "⬆️"}
          </div>

          <h5 className="entry-title">
            {type === "IN" ? "Add Cash In" : "Add Cash Out"}
          </h5>

          <button className="entry-close" onClick={onClose}>
            ✕
          </button>
        </div>

        {/* BODY */}
        <div className="entry-body">

          {/* AMOUNT */}
          <div className="entry-field">
            <label>Amount</label>
            <div className="input-icon-box">
              <i className="bi bi-currency-rupee input-icon"></i>
              <input
                type="number"
                className="entry-input"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                required
              />
            </div>
          </div>

          {/* PAYMENT BY */}
          <div className="entry-field">
            <label>Payment By</label>
            <div className="input-icon-box">
              <i className="bi bi-person input-icon"></i>
              <input
                type="text"
                className="entry-input"
                placeholder="Client / Vendor / Person"
                value={paymentBy}
                onChange={(e) => setPaymentBy(e.target.value)}
              />
            </div>
          </div>

          {/* MODE */}
          <div className="entry-field">
            <label>Payment Mode</label>
            <div className="input-icon-box">
              <i className="bi bi-wallet2 input-icon"></i>
              <select
                className="entry-input"
                value={paymentMode}
                onChange={(e) => setPaymentMode(e.target.value)}
              >
                <option>Cash</option>
                <option>UPI</option>
                <option>Bank Transfer</option>
                <option>Card</option>
                <option>Other</option>
              </select>
            </div>
          </div>

          {/* DATE */}
          <div className="entry-field">
            <label>Date</label>
            <div className="input-icon-box">
              <i className="bi bi-calendar-event input-icon"></i>
              <input
                type="date"
                className="entry-input"
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />
            </div>
          </div>

          {/* NOTE */}
          <div className="entry-field">
            <label>Note</label>
            <textarea
              className="entry-input note-box"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              rows={3}
              placeholder="Write note..."
            ></textarea>
          </div>

          {/* FILE UPLOAD */}
          <div className="entry-field">
            <label>Invoice (Image / PDF)</label>
            <input
              type="file"
              accept="image/*,application/pdf"
              className="entry-input file-input"
              onChange={(e) => setInvoice(e.target.files[0])}
            />
          </div>

          {/* PREVIEW */}
          {invoice && (
            <div className="entry-preview-card">
              <strong className="preview-title">Preview</strong>

              {previewUrl !== "pdf" ? (
                <img src={previewUrl} className="preview-img" alt="preview" />
              ) : (
                <div className="preview-pdf">📄 {invoice.name}</div>
              )}
            </div>
          )}

          {/* ACTIONS */}
          <div className="entry-actions">
            <button className="btn-cancel" type="button" onClick={onClose}>
              Cancel
            </button>

            <button
              className={
                type === "IN" ? "btn-save green-btn" : "btn-save red-btn"
              }
              type="submit"
              onClick={handleSubmit}
            >
              Save Entry
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddEntryModal;
